import * as angular from "angular";
import {IController} from "angular";
import * as _ from 'lodash';
import {PlanProjectEntity} from "../../models/plan-project-entity.model";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {PlanningProjectsService} from "../../services/planning-projects-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class PlanningProjectsScheduledView implements IController {
  projects: any;
  branchIds: any;

  public viewType: any;
  private readonly siteId: any;
  private from: any;
  private to: any;

  /* @ngInject */
  constructor(private IAMPermissions, private splitService, private confirmDialogService: ConfirmDialogService, private planningConstants,
              private planningProjectsService: PlanningProjectsService, private planningDialogService: PlanningDialogService, private $log, private $state) {
    this.siteId = splitService.getSiteId();
  }

  $onInit() {


    this.viewType = this.$state.current.url;

    if (!this.branchIds) {
      this.branchIds = [];
    }
  }

  // ******************************
  //        Public methods
  // ******************************
  onBranchesSelect(branchIds) {
    this.branchIds = branchIds;

    this.getProjectsForCalendar(this.from, this.to, this.branchIds);
    this.$state.go('.', {branchIds: this.branchIds}, {reload: false, notify: false});
  }

  onChangeViewType(view) {
    this.viewType = view;
    if (view === '/calendar') {
      this.$state.go('^.calendar', {}, {notify: true, reload: false});
    } else {
      this.$state.go('^.table', {}, {notify: true, reload: false});
    }
  }

  onSendToPlanning(event, from, to) {
    this.planningDialogService.createOrSelectProject(event, true, from, to, undefined)
      .then((payload: { project: PlanProjectEntity, projectId: string }) => {

        this.createProject(payload.project)
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }


  onRangeChange(from, to) {
    this.from = from;
    this.to = to;
    this.getProjectsForCalendar(from, to, this.branchIds);
  }

  onDeleteProject(project, $event) {
    const text = 'Are you sure you want to delete this project?';
    this.confirmDialogService.confirm('Delete Project', text, $event)
      .then(() => {
        this.deleteProject(project);
      });
  }

  // ******************************
  //        Private methods
  // ******************************

  private getProjectsForCalendar(from, to, branchIds) {

    this.planningProjectsService.getProjects(from, to, branchIds)
      .then((projects) => {
        this.projects = projects;
      });

  }

  private createProject(project) {
    this.planningProjectsService.createProject(project)
      .then((createdProject: any) => {
        this.$state.go(this.planningConstants.states.project, {projectId: createdProject.id});
      })
  }

  private deleteProject(project) {
    this.planningProjectsService.deleteProject(project.id)
      .then(() => {
        this.projects = _.filter(this.projects, function (p) {
          return p.id !== project.id;
        });
      })
  }


}


angular
  .module('bringoz.admin.planning')
  .component('planningProjectsScheduledView', {
    bindings: {
      projects: '<',
      branchIds: '<?'
    },
    template: require('./planning-projects-scheduled-view.html').default,
    controller: PlanningProjectsScheduledView
  });
